/**
 * Служебный объект хоткея оператора. Ни obs-websocket, ни vMix API не сообщают «нажата клавиша»,
 * поэтому хоткей программы включает этот объект, а адаптер ловит включение и сразу выключает его
 * обратно. Имя — то, по которому оператор находит объект, назначая клавишу.
 *
 * OBS: источник «Цвет» (прозрачный, 2×2) в отдельной сцене, которая никогда не выходит в эфир;
 * хоткей — «Показать» его элемента сцены. vMix: инпут Colour с этим заголовком; шорткат —
 * функция `LoopOn` на этот инпут.
 */
export const OPERATOR_MARKER_SOURCE_NAME = 'ImGame метка';

/** Сцена OBS только для служебного источника. Хоткей её элемента работает, и когда сцена не в эфире. */
export const OPERATOR_MARKER_OBS_SCENE_NAME = 'ImGame метки';
